import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../../../../hooks'
import { postMockApplicantMatchRequestInfo } from '../../../../../../RentalPortalApplicant'
import { useApplicantProfileContext } from '../../../../RentalPortalApplicantProfile.hooks'
import { ApplicantFitCheckRequestModal } from '../../ApplicantFitCheckRequestModal'

export function useApplicantFitCheckRequest() {
  const { t } = useTranslation()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const { applicantId, handleCloseModal, handleEntityReload, setModal } =
    useApplicantProfileContext()

  async function sendRequest({ informationTextVersion }) {
    try {
      await postMockApplicantMatchRequestInfo({
        applicantId,
        informationTextVersion,
      })

      handleCloseModal()

      await handleEntityReload()

      handleAddSuccessNotification({
        title: t('RentalPortal.MatchRequestSentKey'),
      })
    } catch {
      handleAddErrorNotification({
        title: t('RentalPortal.MatchRequestErrorKey'),
      })
    }
  }

  function handleOpenRequestModal(match) {
    setModal(
      <ApplicantFitCheckRequestModal
        match={match}
        onClose={handleCloseModal}
        onSend={sendRequest}
      />
    )
  }

  return { handleOpenRequestModal }
}
